// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11221":"ff22cb7f","53613":"4fec0716"}[chunkId] + ".chunk.css";
};